/**
 * RegularListPresenter
 * --
 */
import React from 'react';
import { Content, Title, Row, Col } from 'components';
import { Divider, Spin } from 'antd';
// import { LoadingOutlined } from '@ant-design/icons';
// import { ExpandableContainer, Table, Statistic } from 'components';
// import { Button, Input, Select } from 'antd';

import RegularFilter from './components/RegularFilter';
import RegularSummaryStatics from './components/RegularSummaryStatics';

import RegularData from './components/RegularData';

const RegularListPresenter = ({
  permission,
  loading,
  searchFilter,
  onSearch,
  onReload,
  onChange,
  //
  parcelServiceList,
  parcelAllServiceList,
  currentShop,
  setCurrentShop,
  onResetFilter,
  onSaveDeliveryInfo,
  shipping_type,
  onCancel,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const {
    totalCount,
    processingCount,
    refundCount,

    refundPrice,
    totalPrice,
    totalDiscount,
    orderList,
    orderAllList,
  } = React.useMemo(() => {
    // const completedData = parcelServiceList.filter(
    //   (o) => o.purchase_status !== 'REFUNDED'
    // );

    // 환불/취소 데이터
    const refundedData = parcelServiceList?.filter(
      (o) => o.purchase_status === 'REFUNDED'
    );
    //실 결제
    const totalPrice = parcelServiceList?.reduce(
      (acc, cur) =>
        acc +
          cur.regular_payment_info.reduce(
            (acc, cur) => acc + cur.price ?? 0,
            0
          ) ?? 0,
      0
    );

    //할인
    const totalDiscount = parcelServiceList?.reduce(
      (acc, cur) =>
        acc +
          cur?.regular_payment_info?.reduce(
            (acc, cur) => acc + cur?.discount_price ?? 0,
            0
          ) ?? 0,
      0
    );
    //환불
    const refundPrice = refundedData?.reduce(
      (acc, cur) =>
        acc + cur?.refund?.reduce((acc, cur) => acc + cur?.refund_amount, 0) ??
        0,
      0
    );
    // 배송비 및 포인트 합계 계산
    let totalDeliveryPrice = 0;
    let totalUsePoint = 0;

    parcelServiceList?.forEach((parcel) => {
      const isRegularFirst = parcel?.regular_payment_info?.some(
        (rpi) => rpi.regular_payment_id === 1
      );

      if (isRegularFirst) {
        totalUsePoint += parcel?.shop_order?.use_point ?? 0;
        totalDeliveryPrice += parcel?.shop_order?.final_delivery_price ?? 0;
      }
    });
    //진행건
    const processingList = parcelServiceList?.filter(
      (o) => o.is_active === 'Y'
    );
    return {
      totalCount: parcelServiceList?.length ?? 0,
      processingCount: processingList?.length ?? 0,
      refundCount: refundedData?.length ?? 0,
      totalPrice: totalPrice + totalDeliveryPrice,
      refundPrice: refundPrice,
      totalDiscount: totalDiscount + totalUsePoint,
      orderList: parcelServiceList,
      orderAllList: parcelAllServiceList,
    };
  }, [parcelServiceList]);

  /* ===== FUNCTION ===== */

  /* ===== HOOKS ===== */

  /* ===== RENDER ===== */
  // JSX: start
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title size={3} style={{ marginBottom: 12 }}>
            {/* 배송 목록 */}
            정기 배송 관리
          </Title>

          {/* 요약 */}
          <RegularFilter
            onChange={onChange}
            searchFilter={searchFilter}
            onSearch={onSearch}
            onResetFilter={onResetFilter}
            defaultShop={permission === 'ADMIN' ? null : currentShop}
            onSelect={setCurrentShop}
            permission={permission}
          />
          {/* 요약 */}
          <RegularSummaryStatics
            totalCount={totalCount ?? 0}
            processingCount={processingCount ?? 0}
            refundCount={refundCount ?? 0}
            //
            totalPrice={totalPrice ?? 0}
            totalDiscount={totalDiscount ?? 0}
            refundPrice={refundPrice ?? 0}
          />
          {/* 요약 */}
          <Spin spinning={loading}>
            <Row style={{ minHeight: '50vh' }}>
              {/* === 업체목록 === */}
              {/* {permission === 'ADMIN' && (
                <Col x={3}>
                  <ShopInformationList onChange={setCurrentShop} />
                </Col>
              )} */}
              {/* === Data === */}
              <Col
                // x={permission === 'ADMIN' ? 21 : 24}
                x={24}
                style={{
                  borderLeft: '1px solid #EBEBEB',
                }}
              >
                <RegularData
                  type={shipping_type}
                  orderList={orderList}
                  orderAllList={orderAllList}
                  onSaveDeliveryInfo={onSaveDeliveryInfo}
                  onReload={onReload}
                  onCancel={onCancel}
                />
              </Col>
            </Row>
          </Spin>

          <Divider />
        </Col>
      </Row>
    </Content>
  );
};

export default RegularListPresenter;
